const getQuestionStems = (action) => action.entities?.questionStems || {};

const extractStemsFromQuestions = (action) => {
  const questions = action.entities?.questions || {};
  const extractedStems = {};

  Object.values(questions).forEach((question) => {
    const stems = question.meta?.questionStems || question.meta?.question_stems || [];

    stems.forEach((stem) => {
      if (stem && stem.id) {
        const stemWithQuestionId = {
          ...stem,
          questionId: stem.questionId || stem.question_id || question.id,
          question_id: stem.question_id || stem.questionId || question.id,
        };
        extractedStems[stem.id] = stemWithQuestionId;
      }
    });
  });

  return extractedStems;
};

export default function questionStemsReducer(state = {}, action) {
  switch (action.type) {
    case "LESSONS_FETCHED":
    case "QUESTIONS_FETCHED":
    case "QUESTIONS_SEARCH_FETCHED": {
      const normalizedStems = getQuestionStems(action);
      const extractedStems = extractStemsFromQuestions(action);

      const allStems = {
        ...extractedStems,
        ...normalizedStems,
      };

      if (Object.keys(allStems).length > 0) {
        return {
          ...state,
          ...allStems,
        };
      }
      return state;
    }
    default:
      return state;
  }
}
